import Dashboard from "@/components/pages/dashboard/Dashboard";
let routes = [
  {
    path: "/dashboard",
    component: Dashboard,
    children: Dashboard.children,
    meta: {
      title: 'Brandly | Dashboard',
      requiresAuth: true
    }
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/dashboard.js